<template>
  <div>
    <div class="mx-auto mb-3">
      <error-message :errors="companyNameErrors" />
      <input
        id="name_field"
        v-model="companyName"
        :placeholder="t('belong_company_name')"
        autocomplete="off"
        type="text"
        name="user[company][name]"
        class="form-control"
      >
    </div>
    <div class="mx-auto">
      <error-message :errors="companyUrlErrors" />
      <input
        id="site_url_field"
        v-model="companyUrl"
        :placeholder="t('belong_company_hp_url')"
        autocomplete="off"
        type="text"
        name="user[company][site_url]"
        class="form-control"
      >
    </div>
  </div>
</template>

<script>
import ErrorMessage from "../surveys/ErrorMessage.vue";

import axios from "axios";
import I18n from "../../i18n/i18n";
import "../../i18n/ja";
import { i18n } from "../../mixins/i18n";

export default {
  components: {
    ErrorMessage
  },
  mixins: [i18n],
  props: {
    companyNameErrors: {
      type: Array,
      default() {
        return [];
      }
    },
    companyUrlErrors: {
      type: Array,
      default() {
        return [];
      }
    },
    defaultCompanyName: {
      type: String,
      default: ""
    },
    defaultCompanyUrl: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      companyName: "",
      companyUrl: ""
    };
  },
  created() {
    if (this.defaultCompanyName !== "") {
      this.companyName = this.defaultCompanyName;
    }
    if (this.defaultCompanyUrl !== "") {
      this.companyUrl = this.defaultCompanyUrl;
    }
  },
  mounted() {
    axios.defaults.headers["X-CSRF-TOKEN"] = document.getElementsByName("csrf-token")[0].content;
    axios.defaults.headers.X_REQUESTED_WITH = "XMLHttpRequest";
  }
};
</script>

<style lang="scss" scoped>
#companies_index {
  li {
    a:hover {
      background: #fafafa;
    }
  }
}
</style>
